const ActionsTableEnum = Object.freeze({
	LINK: 'LinkIcon',
	EDIT: 'EditIcon',
	DUPLICATE: 'DuplicateIcon',
	REPORT: 'ReportIcon',
	DELETE: 'DeleteIcon',
});

export default ActionsTableEnum;
